import { RootState } from "@/store/store";
import { getAiKubernetesRecommendationsEndpointSelector } from "@/store/ai-kubernetes-recommendations/selectors/getAiKubernetesRecommendationsEndpointSelector";

export const aiKubernetesRecommendationsSelector = (
  state: RootState,
  resourceId?: string,
) => {
  return getAiKubernetesRecommendationsEndpointSelector(resourceId)(state)
    ?.data;
};
